const keywords = [
	"Sharjeel Faiq",
	"Senior Full-Stack Developer",
	"Full Stack Developer Pakistan",
	"React Developer Pakistan",
	"Node.js Developer Pakistan",
	"Freelance Full-Stack Developer",
	"MERN Developer",
	"PERN Developer",
	"React Developer",
	"Node.js Developer",
	"Express Developer",
	"MongoDB Developer",
	"PostgreSQL Developer",
	"SaaS Dashboard Developer",
	"AI Automation Developer",
	"SaaS Developer",
	"AI integrations",
];

const CANONICAL_URL = "https://sharjeelfaiq.vercel.app";
const DEFAULT_IMAGE = "/homepage.jpg";

const SEO = [
	{
		page: "home",
		path: "/",
		title: "Sharjeel Faiq | Full Stack Developer Pakistan",
		description:
			"Hire Sharjeel Faiq, a full stack developer in Islamabad, Pakistan building React, Node.js, SaaS, database, DevOps, and AI integration solutions.",
		keywords,
	},

	{
		page: "about",
		path: "/about",
		title: "About Sharjeel Faiq | React and Node.js Developer Pakistan",
		description:
			"Learn about Sharjeel Faiq's full-stack engineering work across React, Node.js, MERN, PERN, databases, DevOps, AI integrations, and automation.",
		keywords,
	},

	{
		page: "articles",
		path: "/articles",
		title: "Articles | Sharjeel Faiq",
		description:
			"Sharjeel Faiq's portfolio is currently focused on projects, technical capabilities, and direct contact.",
		keywords,
		noindex: true,
	},

	{
		page: "projects",
		path: "/projects",
		title: "Projects | Sharjeel Faiq",
		description:
			"Selected projects by Sharjeel Faiq covering SaaS dashboards, high-volume transaction systems, performance improvements, AI automation, and MERN products.",
		keywords,
	},

	{
		page: "contact",
		path: "/contact",
		title: "Contact Sharjeel Faiq | Full-Stack Developer",
		description:
			"Contact Sharjeel Faiq for freelance full-stack development, React, Node.js, database, DevOps, integration, and AI automation work.",
		keywords,
	},
];

export { CANONICAL_URL, DEFAULT_IMAGE };
export default SEO;
